<template>
  <div class="home">
    <div class="container">
      <Header />
      <div class="row bg_ffffff">
        <div class="col-12 col-sm-12 padding_30 padding_top_0">
          <div class="csfont_Signika_Lite color_6d6e71 text-left font-size-16">
              <div class="p-500">
                  <center>
                  <h3>Thank you for submitting the TICA Membership Application Form.</h3>
                  <h3>We will review the information and get back to you soon.</h3>
                  </center>
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
// CSS
import "@/assets/maincss/bootstrap.min.css";
import "@/assets/maincss/animate.css";
import "@/assets/maincss/fontface.css";
import "@/assets/css/font.css";
import "@/assets/maincss/custom.css";
import "@/assets/css/spacing.css";
import "vue-multiselect/dist/vue-multiselect.min.css";

// Component
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";


export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
    }
  },
};
</script>

<style scoped>
.w-100 {
  width: 100% !important;
}
.bg_dark_blue {
  background-color: #102f50 !important;
}
.text-secondary {
  border-top: 1px solid #bfc6cc !important;
}
.catgory-input {
  position: absolute !important;
  right: 0 !important;
  padding-right: 5% !important;
}
.home {
  background-color: #3c3c3b !important;
  font-family: Georgia, Times, serif !important;
}
input[type="file"] {
  display: none !important;
}
.custom-file-upload {
  border: 1px solid #ccc !important;
  display: inline !important;
  padding: 3px 12px !important;
  cursor: pointer !important;
  white-space: normal !important;
}
.btn-app {
  color: #fff !important;
  background-color: #102f51 !important;
}
.btn-app:hover {
  color: #fff !important;
  background-color: #235a99 !important;
}
.text-truncate {
  white-space: nowrap !important;
  padding-right: 5rem !important;
  padding-left: 1rem !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.w-45 {
  width: 45%;
}
.other-btn {
  padding: 6px 25px !important;
}
.p-500{
    padding: 12rem 0;
}
</style>
